module.exports = __webpack_public_path__ + "img/Tacco_DX.0afc5a86.png";